<template>
  <div v-if="this.licenceOK === true && this.userOK === true">
    <v-layout class="text-xs-right">
      <v-btn @click="openDialog()" :color="ui.btnColor" flat dark>
        <v-icon left>
          search
        </v-icon>
        search
      </v-btn>
      <v-dialog v-model="dialog" max-width="500">
        <v-card>
          <v-card-title class="title wplblue1--text">
            {{searchObj.title}}
            <v-spacer/>
            <v-chip :color="ui.bkgdColorSecondary" :class="ui.textSubheading"
            v-if="this.getSearchResults !== null && this.searchObj.enableCtr">
              <v-avatar>
              <v-icon> playlist_add </v-icon>
              </v-avatar>
              {{this.getSearchResults.length}}
            </v-chip>
          </v-card-title>
          <v-layout row class="ml-3 mr-4"
          v-if="
          this.getOrgDetailBasic !== null &&
          this.getOrgDetailBasic !== undefined
          ">
            <div :class="ui.textSubheadingBold">
              {{getOrgDetailBasic.id}} {{getOrgDetailBasic.title}}
            </div>
            <v-spacer/>
            <div :class="ui.textSubheadingBold">
              {{displayDocumentIDGTypeA(this.getDetailBasic.tag, this.getDetailBasic.idg)}}
            </div>
          </v-layout>
          <v-progress-linear :color="ui.btnColor" height="1" value="100">
          </v-progress-linear>
          <!-- {{this.search}} -->
          <v-form
            ref="form"
            v-model="valid"
            v-on:submit.prevent="validate"
            lazy-validation>
            <v-container>
              <v-layout row>
                <v-flex xs12 md12>
                  <v-text-field
                    v-model="search.title"
                    label="search report title"
                    prepend-icon="title"
                    hint="inspection and test result"
                    persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 md12>
                  <v-text-field
                    v-model="search.aid"
                    label="search asset"
                    prepend-icon="emoji_transportation"
                    hint="asset tag"
                    persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row v-if="this.data.dis === null">
                <v-flex xs12 md12>
                  <v-select
                    v-model="search.dis"
                    :items="engineeringDiscipline"
                    color="wplblue0"
                    prepend-icon="engineering"
                    hint="discipline"
                    persistent-hint
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row v-if="this.data.dis !== null">
                <v-flex xs12 md12>
                  <v-text-field
                    v-model="search.ept"
                    label="search procedure"
                    prepend-icon="assignment"
                    hint="procedure template"
                    persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <!-- <v-layout row>
                <v-flex xs12 md12>
                  <v-text-field
                    v-model="search.ept"
                    label="days since create"
                    prepend-icon="date_range"
                    hint="age of results"
                    persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout> -->
            </v-container>
            <v-layout  row>
              <v-btn @click="closeDialog()" :color="ui.btnColor" flat>
                <v-icon left> exit_to_app </v-icon>
                Close
              </v-btn>
              <v-btn :color="ui.btnColorBkgd" icon
              v-if="this.search.enableFacilityOnly">
                <v-icon :color="ui.btnColor"> place </v-icon>
              </v-btn>
              <v-btn :color="ui.colorBlue" flat dark
              class="hidden-xs-only"
              v-if="this.getSearchResults !== null && this.searchObj.enableCtr">
                <v-icon left :color="ui.colorBlue"> manage_search </v-icon>
                1000
                <!-- {{this.getUser.pref.search.limit}} -->
              </v-btn>
              <v-spacer/>
              <div v-if="enableSpinBtnSearch === false">
                <v-btn :disabled="disableSearchReport" :color="ui.btnColor"
                  @click="validate" flat>
                  <v-icon left> search </v-icon>
                    search
                </v-btn>
              </div>
              <div v-else>
                <BtnSpin :btnSpec="btnInfo1"/>
              </div>
            </v-layout>
          </v-form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import accessFunctions from "@/support/access/mixins/accessFunctions.js";
import BtnSpin from "@/frame/animation/components/BtnSpin";
import searchReport from "@/engineering/report/mixins/searchReport.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import describeDocument from "@/data/describe/mixins/describeDocument.js";
import licenceFunctions from "@/admin/functions/mixins/licenceFunctions.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import registerFunctions from "@/data/functions/mixins/registerFunctions.js";
import techOptions from "@/data/options/mixins/techOptions.js";
export default {
  // eslint-disable-next-line
  mixins: [
    searchReport,
    apptheme,
    dataSources,
    accessFunctions,
    displayFunctions,
    describeDocument,
    licenceFunctions,
    adminFunctions,
    registerFunctions,
    techOptions
  ],
  components: {
    BtnSpin
  },
  props: {
    data: {
      type: Object
    }
  },
  computed: {
    ...mapGetters([
      "getUser",
      "getProcedure",
      "getCurrentPage",
      "getSearchResults",
      "getOrgDetailBasic",
      "getRegisterInfo"
    ]),
    disableSearchReport() {
      let logic = null;
      if (this.data.dis !== null && this.data.dis !== "") {
        if (
          this.search.title === "" &&
          this.search.aid === "" &&
          this.search.ept === ""
        ) {
          logic = true;
        } else {
          logic = false;
        }
      } else {
        if (this.search.title === "" && this.search.aid === "") {
          logic = true;
        } else {
          logic = false;
        }
      }
      return logic;
    },
    searchObj() {
      let obj = {
        title: "Search d",
        icon: "",
        enableIdSearch: true,
        enableCtr: false
      };
      obj.title = this.data.title;
      if (
        this.getSearchResults !== null &&
        this.getSearchResults !== undefined &&
        this.getSearchResults.length > 0
      ) {
        // tag = this.getSearchResults[0].basic.tag;
        // DEFINE TITLE
        obj.title = this.data.title;
        // obj.icon = this.defineDocumentFromTag(this.data.tag).icon;
        obj.enableCtr = true;
      }
      return obj;
    }
  },
  data() {
    return {
      dialog: false,
      valid: false,
      enableSpinBtnSearch: false,
      search: {
        tag: "", // tag
        id: "", // id for search
        arch: "",
        title: "", // title for search
        ft: "", // facility title
        type: "", // electrical result type
        theme: "", // theme
        ept: "", // engineering procedure title;
        epid: "", // engineering procedure id;
        days: "", // how old / how many days
        life: "", // life cycle
        dis: "", // engineering discpline
        aid: "", // asset id or asset tag (example A8911.KM01S)
        stat: "", // review or verified
        enableFt: false, // genable facility title search (generic)
        enableFacilityOnly: false, // emebedded list like f2
        dbs: "" // data base source
      },
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: "flat"
      }
    };
  },
  methods: {
    openDialog() {
      console.log("");
      console.log("OPENED SEARCH TAG");
      console.log(this.data);
      this.dialog = true;
      this.enableSpinBtnSearch = false;
      this.search.dis = this.data.dis;

      if (this.data.tag !== undefined) {
        this.search.tag = this.data.tag;
      }
      // CHECK if FACILITY SEARCH is enabled
      this.search.enableFt = true;

      // DEFINE DB
      let db = this.defineDataSourceFromTag(this.data.tag);
      this.search.dbs = db;

      // DEFINE REG
      // let reg = this.generateRegisterInfo(this.getDetailBasic);
      // this.$store.dispatch("changeRegisterInfo", reg);

      // console.log("");
      // console.log(">>> SEARCH OPENED <<<");
      // console.log("TAG :              " + this.data.tag);
      // console.log("ARCHIVE :          " + this.searchArchive);
      // console.log("DBS :              " + this.search.dbs);
      // console.log("Facility Search:   " + this.search.enableFt);
      // console.log("Facility Only:     " + this.search.enableFacilityOnly);
      // console.log("Facility Title:    " + this.getUser.pref.select.fname);
      // console.log(this.search);
    },
    closeDialog() {
      this.dialog = false;
      // this.$store.dispatch("changeDataReach", "");
      // this.$store.dispatch("changeDataSource", "");
    },
    validate() {
      if (this.$refs.form.validate() === true) {
        this.enableSpinBtnSearch = true;
        let reg = {
          title: this.search.title,
          dis: this.search.dis,
          type: "dis",
          aid: this.search.aid,
          ept: this.search.ept
        };
        this.$store.dispatch("changeRegisterInfo", reg);
        this.searchReportsDiscipline(this.search);
      }
    }
  }
};
</script>
